import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { txt } from 'libs/i18n';
import { App, Popconfirm, Tooltip } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useSession } from 'components/Authenticated';
import IconButton from 'components/IconButton';
import { useSwitch } from 'hooks/useSwitch';
import ProjectsDeleteDialog from '../../ProjectsDeleteDialog';
import toolbarStyles from '../style.module.less';
const DeleteButton = ({ selectedProjects, isOpenTeam, selectionEmpty, onComplete, }) => {
    const { message, notification } = App.useApp();
    const [open, onOpen, onClose] = useSwitch();
    const { session } = useSession();
    const canDeleteTeamProjects = session.login.hasClaim('team:deleteProjects');
    const areTeamProjectsIncluded = useMemo(() => selectedProjects.some((project) => project.isTeamProject), [selectedProjects]);
    const hasSharedProjects = useMemo(() => selectedProjects.some((project) => project.shareCount > 1), [selectedProjects]);
    const canDeleteOpenTeamProjects = isOpenTeam && canDeleteTeamProjects;
    const cannotDeleteTeamProjects = !canDeleteOpenTeamProjects && areTeamProjectsIncluded;
    const handleDeleteFinished = (successfulCount, failedCount) => {
        if (failedCount === 0) {
            void message.success(`${txt('successfullyDeleted')}. ${txt('numOfProjs')}: ${successfulCount}`);
        }
        else {
            notification.error({
                message: txt('failedToDelete'),
                description: `${txt('numOfProjs')}: ${successfulCount};
                        ${txt('failedToDelete')}: ${failedCount}`,
                placement: 'topRight',
                duration: 10,
            });
        }
        onComplete();
        onClose();
    };
    return (_jsxs(_Fragment, { children: [selectionEmpty ? (_jsx(Tooltip, { title: txt('delete'), children: _jsx("div", { children: _jsx(IconButton, { className: toolbarStyles.toolbarButton, id: "deletePP", disabled: true, children: _jsx(DeleteOutlined, {}) }) }) })) : (_jsx(Popconfirm, { title: (_jsxs(_Fragment, { children: [_jsx("p", { children: _jsx("strong", { children: txt('deleteProjects') }) }), _jsx("p", { children: `${txt('numOfProjsToDelete')}: ${selectedProjects.length}` }), hasSharedProjects && (_jsx("p", { children: txt('deleteShared') }))] })), okText: txt('delete'), okType: "primary", okButtonProps: { danger: true }, onConfirm: onOpen, cancelText: txt('cancel'), children: _jsx(Tooltip, { title: !canDeleteOpenTeamProjects && areTeamProjectsIncluded ? txt('cannotDelete') : txt('delete'), children: _jsx("div", { children: _jsx(IconButton, { className: toolbarStyles.toolbarButton, danger: true, disabled: cannotDeleteTeamProjects, children: _jsx(DeleteOutlined, {}) }) }) }) })), open ? (_jsx(ProjectsDeleteDialog, { projects: selectedProjects, onClose: onClose, onDeleteFinished: handleDeleteFinished })) : null] }));
};
export default DeleteButton;
